import { CommonData } from "../datastructures/gamestate/gameData";
import {  enablePlay, stopAutoPlay } from "../functions/Functions_GameBar";

// import { GameData } from "../gamestate/gameData";
// import { disableAllBtns } from "../globalFunctions";


export function jackppotGameFadeIn(activeGameData: CommonData) {
   activeGameData.jackPotGame.launchJackpot();
}
export function highlightJackpotBox(activeGameData: CommonData, boxToHighlight: Array<number>) {
   activeGameData.jackPotGame.setHighlightOnLabel(boxToHighlight);
}
export function jackpotCoinsJump(activeGameData: CommonData, repeat: number) {
   activeGameData.jumpCoin.startJump();
   if (repeat > 0) {
      setTimeout(() => {
         jackpotCoinsJump(activeGameData, repeat - 1)
      }, 2200);
   }


}
export function playJackpotMusic(activeGameData: CommonData, bool: boolean) {
   activeGameData.jackPotGame.setMusicOn(bool);

}
//show / hide jackpot counter ingame (outside of jackpot game)
// export function showIngameJackpotCounter(activeGameData: CommonData, bool: boolean) {
//    if (bool) {
//       activeGameData.jackPotGame.setCounterVisible(true);//.animatedLabel.parent.alpha=1;

//    }
//    else {
//       activeGameData.jackPotGame.setCounterVisible(false);//animatedLabel.parent.alpha=1;

//    }
// }
export function startJackpot(activeGameData: CommonData) {
   // console.log(activeGameData)


   enablePlay(false, activeGameData);
   activeGameData.playable = true;
   stopAutoPlay(activeGameData);
   activeGameData.disableAllBtns(activeGameData);
   activeGameData.jackPotGame.launchJackpotIntro();//startjackpot animation;


}
export function displayJackpotBGCounter(activeGameData: CommonData, bool: boolean) {

   

   activeGameData.jackPotGame.setCounterVisible(bool);

}

